import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { FixtureProfileResponse } from "~types/fixtureProfile.ts";
import { removeEmptyFields } from "~utils/removeEmptyFields.ts";
import { transformListResponse } from "~utils/transformListResponse.ts";

type Props = {
  customParams: Record<string, string>;
  enabled?: boolean;
};

export const useFetchMatchProfileList = ({ customParams, enabled = true }: Props) => {
  const request = useApi();
  const { organizationId, sport } = useParams();

  const params = new URLSearchParams(removeEmptyFields(customParams) as Record<string, string>);

  return useQuery({
    queryKey: ["matchProfiles", sport, organizationId, customParams],
    enabled,
    queryFn: () =>
      request<FixtureProfileResponse>(`${sport}/o/${organizationId}/fixtureProfiles?${params.toString()}`).then((response) =>
        transformListResponse(response),
      ),
  });
};
